import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { CreateEquipmentProblem, EquipmentProblem, EquipmentProblemListResponse, EquipmentProblemQueryParams, IEquipment } from '@frontend/equipment/types';

export class EquipmentProblemClient extends APIClient {
    public static readonly endpoint = '/equipment-api/v1';

    public static async fetchEquipmentProblems(
        accountId: string,
        equipmentId: string,
        queryParams?: ApiQueryParams<EquipmentProblemQueryParams>
    ): Promise<EquipmentProblemListResponse> {
        return this.apiPaginated<EquipmentProblemListResponse, EquipmentProblemQueryParams>(
            `${this.endpoint}/accounts/${accountId}/equipments/${equipmentId}/problems`
        );
    }

    public static async postEquipmentProblem(accountId: string, equipmentId: string, body: CreateEquipmentProblem): Promise<IEquipment> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/equipments/${equipmentId}/problems`, body);
        return this.handleResponse<IEquipment>(response);
    }

    public static async fetchEquipmentProblem(accountId: string, equipmentId: string, problemId: string): Promise<EquipmentProblem> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/equipments/${equipmentId}/problems/${problemId}`);
        return this.handleResponse<EquipmentProblem>(response);
    }

    public static async deleteEquipmentProblem(accountId: string, equipmentId: string, problemId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/equipments/${equipmentId}/problems/${problemId}`);
        return this.handleVoidResponse(response);
    }
}
